export default {
    system: '颂明医疗数字病理云空间',
    login: {
        username: '手机号',
        password: '密码',
        oldPassword: '旧密码',
        login: '登录',
        loginOut: '退出登录',
    },
    header: {
        system: '系统',
        category: '类别管理',
        user: '用户管理',
        auth: '权限管理',
        function: '功能管理',
        case: '病例',
        album: '专辑',
        share: '分享',
    },
    manage: {
        add: '添加',
        addUser: '添加用户',
        addRole: '添加角色',
        role: '角色',
        roleName: '角色名称',
        auth: '权限',
        edit: '编辑',
        authEdit: '权限编辑',
        delete: '删除',
        confirm: '确认',
        operation: '操作',
        share: '分享',
        browse: '浏览',
        view: '查看',
        save: '保存',
        back: '返回',
        search: '搜索'
    },
    case: {
        case: '病例',
        caseNo: '病例号',
        title: '标题',
        name: '姓名',
        age: '年龄',
        sex: '性别',
        male: '男',
        female: '女',
        null: '无',
        specimen: '样本',
        clinicalData: '临床数据',
        generalObservations: '大体所见',
        diagnosis: '诊断',
        list: '病例列表'
    },
    album: {
        title: '专辑标题',
        describe: '专辑描述',
        list: '专辑列表'
    },
    share: {
        slice: '切片',
        createTime: '创建时间',
        expireTime: '过期时间',
        permanent: '永久',
        timeLimit: '限时',
        isPassword: '是否需要分享码',
        yes: '是',
        no: '否',
        password: '分享码',
        password_confrim: '分享码验证',
        remark: '备注',
        list: '分享列表'
    },
    body: {
        upload: '上传',
        removeTo: '移动到',
        download: '下载',
        delete: '删除',
        share: '分享',
        share_click: '点击分享',
        ctrl_c: '复制',
        close: '关闭',
        copy_success: '复制成功',
        copy_fail: '复制失败',
        error: '切片资源已丢失或损坏'
    },
    upload: {
        list: '上传列表',
        select: '选择文件',
        selectUpload: '选择文件上传',
        start: '开始上传',
        complete: '所有文件上传完成',
        error1: '上传失败',
        error2: '上传失败,上传容量已满',
        begin: '开始上传, 可点击右上角图标查看上传状态'
    },
    setting: {
        title: '设置主目录',
        Current_directory: '当前主目录',
        set: '设为主目录',
        null: '暂无子目录'
    }
}
